function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFacebookMessenger = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
  id: "facebook-messenger_svg__a",
  cx: 101.9,
  cy: 809,
  r: 1.1,
  fx: 101.9,
  fy: 809,
  gradientTransform: "matrix(16 0 0 -16 -1627.72 12960)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    stopColor: "#09f",
    stopOpacity: 1
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6,
  style: {
    stopColor: "#a033ff",
    stopOpacity: 1
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9,
  style: {
    stopColor: "#ff5280",
    stopOpacity: 1
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#ff7061",
    stopOpacity: 1
  }
}))), /*#__PURE__*/React.createElement("path", {
  d: "M8 0C3.492 0 0 3.3 0 7.762c0 2.332.957 4.347 2.512 5.738.129.117.21.281.215.457l.043 1.422c.007.215.117.41.3.523.18.114.403.13.598.043l1.59-.699a.64.64 0 0 1 .426-.031c.73.2 1.507.308 2.316.308 4.508 0 8-3.304 8-7.761S12.508 0 8 0m0 0",
  style: {
    stroke: "none",
    fillRule: "nonzero",
    fill: "url(#facebook-messenger_svg__a)"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "m3.195 10.031 2.352-3.73a1.203 1.203 0 0 1 1.734-.32l1.871 1.402a.48.48 0 0 0 .578 0l2.524-1.918c.336-.254.777.148.55.508l-2.35 3.726a1.203 1.203 0 0 1-1.735.32L6.848 8.618a.48.48 0 0 0-.578 0l-2.524 1.918c-.336.254-.777-.148-.55-.504m0 0",
  style: {
    stroke: "none",
    fillRule: "nonzero",
    fill: "#fff",
    fillOpacity: 1
  }
}));
export default SvgFacebookMessenger;